module.exports = __webpack_public_path__ + "static/media/gma.d56156a9.jpg";